/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

//sure tslint, have your silly "I" prefix and sound like a lolcat then
export interface IHasType {
	type: string;
}

function cleanActionType(action: IHasType | string) {
	if (typeof action === 'string') {
		return action;
	} else if (action && action.type) {
		return action.type;
	}
}

export function isActionIncluded(
	action: IHasType | string,
	includedActions: { [key: string]: string },
	moreIncludeActions?: { [key: string]: string }
) {
	//FUTURE NOTE: do a proper spread syntax implementation for additional lists if we ever actually need more than 2
	return (
		!!includedActions[cleanActionType(action)] ||
		(moreIncludeActions && !!includedActions[cleanActionType(action)])
	);
}
